<template>
  <header class="header-global py-5 bg-primary">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="../../public/logo/white.png" alt="logo" />
      </router-link>
      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <router-link to="/">
            <img src="../../public/logo/blue.png" alt="logo" />
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul v-if="IsLoggedIn" class="navbar-nav ml-lg-auto">
        <li class="nav-item">
          <a class="nav-link" href="#">Welcome {{ GetLoggedInUser }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/Users">Users</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/unApproved">Un-Approved</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/approved">Approved</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/taura">Taura</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/customersms">Send sms</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/rejected">Rejected</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/balance">Balance</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/generalsettings">General Settings</a>
        </li>
        <base-dropdown tag="li" class="nav-item" title="Reports" menu-classes="dropdown-menu-right">
          <a class="dropdown-item" href="/metrics">Metrics</a>
          <a class="dropdown-item" href="/walletreport">Wallet Report</a>
          <a class="dropdown-item" href="/walletcommissionreport">Commission Report</a>
          <a class="dropdown-item" href="/referralCommissionReport">Referral Commission Report</a>
          <a class="dropdown-item" href="/customeroveraltransactions">Customer Transactions</a>
          <a class="dropdown-item" href="/customertransactions">Transaction Status</a>
          <a class="dropdown-item" href="/stockorders">Stock Orders</a>
          <a class="dropdown-item" href="/stockorderaccess">Stock Order Access</a>
          <a class="dropdown-item" href="/relayedsms">Relayed SMS</a>
          <a class="dropdown-item" href="/relayeddeposits">Relayed Deposits</a>
          <a class="dropdown-item" href="/productreport">Product Report</a>
          <a class="dropdown-item" href="/agentmonthlysales">Agent Monthly Sales</a>
          <a class="dropdown-item" href="/agentgrowthreport">Agent Growth Report</a>
          <a class="dropdown-item" href="/usersreport">User Signon Report</a>
        </base-dropdown>
        <li class="nav-item">
          <a class="nav-link" @click="SignOut" href="#">LogOut</a>
        </li>
      </ul>
      <ul v-else class="navbar-nav ml-lg-auto">
        <li class="nav-item">
          <a class="nav-link" href="/login">Sign In</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="register">Sign Up</a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { userAuth } from "../services/security";
import config from "@/settings/config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Loading,
  },
  data: function () {
    return {
      register: "/register",
      isLoading: true,
      fullPage: true,
    };
  },
  computed: {
    IsLoggedIn: function () {
      return userAuth.data().user.isAuthenticated;
    },
    GetLoggedInUser: function () {
      return userAuth.GetUserName();
    },
  },
  methods: {
    SignIn: async function () {
      await userAuth.signIn("/users");
    },
    SignOut: async function () {
      await userAuth.SignOut();
    },
  },
};
</script>
<style>
</style>